import type { Company } from "@prisma/client";

export default function hasBookingTerms(
  company: Pick<Company, "bookingTerms">,
) {
  return company.bookingTerms.trim().length > 0;
}
